import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterLinkWithHref, RouterLinkActive } from '@angular/router';

import { ThemeServiceService } from '../../_services/_common/theme-service.service';
import { AUTH_ROUTE_PREFIX } from '@app/enums';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterLinkWithHref, RouterLinkActive],
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  loginPath = `${AUTH_ROUTE_PREFIX}/login`;
  registerPath = `${AUTH_ROUTE_PREFIX}/register`;

  constructor(private themeService: ThemeServiceService) {}

  ngOnInit() {
    this.themeService.setTheme('light');
  }

  isNavbarOpen = false;

  toggleNavbar(): void {
    this.isNavbarOpen = !this.isNavbarOpen;
  }
}
